import { motion } from 'motion/react';
import { CSSProperties, FunctionComponent, MouseEventHandler, ReactNode } from 'react';
import { adaptTransition } from '../../util/Animation';
import { motionStyleSheet } from '../../util/Styles';

type Props = {
	/** If false, show front-side, if true, show back-side */
	flipped: boolean;
	onClick?: MouseEventHandler;
	front: ReactNode;
	back: ReactNode;
	/** Flip direction. Default is 'horizontal'. */
	direction?: 'horizontal' | 'vertical';
	'aria-label'?: string;
	style?: CSSProperties;
};

/** Flippable two-sided card */
export const FlipCard: FunctionComponent<Props> = (props) => {
	const horizontal = props.direction !== 'vertical';

	return <motion.div
		style={{
			perspective: '1000px', // Adds depth for 3D animation
			cursor: 'pointer',
			...props.style,
		}}
	>
		<motion.div
			onClick={props.onClick}
			tabIndex={0}
			aria-label={props['aria-label'] + (props.flipped ? '. Currently revealed.' : ' hidden. Click to reveal.')}
			initial={false}
			animate={{ [horizontal ? 'rotateY' : 'rotateX']: props.flipped ? 180 : 0 }} // Animates the flip
			transition={adaptTransition({ duration: 1 })}
			style={{
				width: '100%',
				height: '100%',
				position: 'relative',
				transformStyle: 'preserve-3d',
			}}
		>
			{/* Front Side */}
			<motion.div style={styles.side}>
				{props.front}
			</motion.div>

			{/* Back Side */}
			<motion.div style={{
				...styles.side,
				transform: horizontal ? 'rotateY(180deg)' : 'rotateX(180deg)'
			}}>
				{props.back}
			</motion.div>
		</motion.div>
	</motion.div>;
};

const styles = motionStyleSheet({
	side: {
		position: 'absolute',
		backfaceVisibility: 'hidden',
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	}
});